import {createI18n} from 'vue-i18n'

import pt from './lang-pt'
import en from './lang-en'

export default createI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
  messages: {
    pt,
    en,
  },
})
